// ─────────────────────────────────────────────────────────────────────────────
// services.js - Salient services data
// ─────────────────────────────────────────────────────────────────────────────

import technical from '../assets/images/services/technical.jpg'
import labtesting from '../assets/images/services/lab-testing.jpg'
import involved from '../assets/images/services/involved.jpg'
import aftersales from '../assets/images/services/aftersales.jpg'

export const services = [
  {
    id:          'technical-consultation',
    slug:        'technical-consultation',
    name:        'On-Farm Technical Consultation',
    shortName:   'Technical Advice',
    tagline:     'Expert guidance delivered directly to your farm.',
    description: 'Our team of technical experts visits farms directly to assess nutritional programmes, diagnose performance challenges, and provide tailored recommendations. We work alongside your veterinarians, farm managers, and feed millers to deliver individual, customer-oriented solution concepts that ensure high service quality.',
    image:       technical, // src/assets/images/services/consultation.jpg
    why: [
      'On-farm visits by qualified technical experts',
      'Individual, customer-oriented solution concepts',
      'Nutritional programme assessment and optimisation',
      'Collaboration with your veterinarians and farm managers',
      'Follow-up support after every consultation',
    ],
    deliveryMethods: ['Field Visits', 'WhatsApp', 'Phone Hotline'],
    icon: 'consultation',
  },
  {
    id:          'lab-testing',
    slug:        'lab-testing',
    name:        'Laboratory Testing',
    shortName:   'Lab Testing',
    tagline:     'Information is power - get the data you need.',
    description: 'To make the right nutritional decisions, obtaining adequate information beforehand is absolutely necessary. We support clients with access to laboratory testing services to assess feed quality, water quality, and animal health parameters - enabling data-driven nutritional decisions that deliver measurable results.',
    image:       labtesting, // src/assets/images/services/lab-testing.jpg
    why: [
      'Feed quality and composition analysis',
      'Water quality assessment for livestock systems',
      'Animal health and performance parameter testing',
      'Data-driven nutritional programme design',
      'Results interpreted by our technical team',
    ],
    deliveryMethods: ['Lab Analysis', 'Field Sampling', 'Technical Report'],
    icon: 'lab',
  },
  {
    id:          'training-programs',
    slug:        'training-programs',
    name:        'Training Programmes',
    shortName:   'Training',
    tagline:     'Building knowledge across Sri Lanka\'s livestock sector.',
    description: 'We conduct training programmes for farmers, feed millers, veterinarians, and agricultural engineers on best practices in livestock nutrition, biosecurity, and the correct use of nutritional products. Our training sessions are designed to build long-term capability across Sri Lanka\'s animal production sector.',
    image:       involved, // src/assets/images/services/training.jpg
    why: [
      'Hands-on training for farmers and farm managers',
      'Specialist sessions for veterinarians and feed millers',
      'Best practice guidance on nutritional product use',
      'Biosecurity and disease prevention workshops',
      'Technical presentations and knowledge exchange',
    ],
    deliveryMethods: ['On-Farm Workshops', 'Group Sessions', 'Technical Webinars'],
    icon: 'training',
  },
  {
    id:          'after-sales-support',
    slug:        'after-sales-support',
    name:        'After-Sales Technical Support',
    shortName:   'After-Sales Support',
    tagline:     'We\'re with you every step of the way.',
    description: 'Responsive expert support is available after every sale. Our technical team is reachable via field visits, WhatsApp, and our dedicated phone hotline - ensuring you always have fast access to expert answers for any technical questions that arise during your production cycle.',
    image:       aftersales, // src/assets/images/services/support.jpg
    why: [
      'Dedicated phone hotline for fast technical answers',
      'WhatsApp support for real-time guidance',
      'Follow-up field visits when needed',
      'Product application and dosage guidance',
      'Ongoing programme monitoring and adjustment',
    ],
    deliveryMethods: ['Field Visits', 'WhatsApp', 'Phone Hotline'],
    icon: 'support',
  },
]

export const getServiceBySlug = (slug) =>
  services.find(s => s.slug === slug) || null

export default services